import React from "react";
import minus from "../assets/images/minus-item.png";
import plus from "../assets/images/plus-item.png";
import { v4 as uuidv4 } from 'uuid';

import "./newTrip.css";
// import InputLabel from "@mui/material/InputLabel";
import { useDispatch, useSelector } from "react-redux";
import { AddAgeRow, DeleteAgeRow, fetchCurrentTripForm } from "../redux/features/tripFormSlice";
// import Select from "@mui/material/Select";
export default function Counter() {
  const tripStateData = useSelector(fetchCurrentTripForm)
  const dispatch = useDispatch()

  const handelAdd = () => {
    const countChild = tripStateData?.ageRows.length === 0 ? 1 : tripStateData?.ageRows?.length + 1
    dispatch(AddAgeRow({ id: countChild, value: "" }));
  };




  const handleDecrease = () => {
    dispatch(DeleteAgeRow())
  };
  return (
    <div>
      <div className="counter">
        <div className={tripStateData?.ageRows?.length === 0 ? "minus-symbol" : "symbol"} onClick={handleDecrease}>
          <img src={minus} alt="minus" />
        </div>

        <div className={tripStateData?.ageRows?.length === 0 ? "alter-amount" : "amount"}>
          <p>{tripStateData?.ageRows?.length}</p>
        </div>
        <div className="symbol" onClick={handelAdd}>
          <img src={plus} alt="plus" />
        </div>
      </div>

    </div>
  );
}
